import React from 'react';
import CreditCards from "./CreditCards";

import RenderField from './RenderField';
import { Field, formValueSelector } from 'redux-form';
import {connect} from "react-redux";

class CreditCardMontemar extends React.Component {

    state = {
        number: "",
        showIssuer: true,
        showName: false,
        showExpiry: false,
        showChip: false,
        numberCustom: {
            min: 12,
            max: 16,
            format: '••••••••••••••••'
        },
        focused: 'number',
        issuer: 'montemar',
        issuerCustom: {
            image: require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)
        }
    };

    componentDidUpdate(prevProps,) {
        if (this.props.last_digits === undefined && this.state.number !== ''){
            this.setState({
                number: ''
            });
        }
        else if (this.props.last_digits !== prevProps.last_digits) {
            this.setState({
                number: this.props.last_digits
            });
        }
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <div className="form-group">
                            <CreditCards  {...this.state} />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <div className="form-group">
                            <Field className="form-control" name="last_digits_credit_card" autoComplete="off"
                                   component={RenderField} type="number" maxLength={4}
                                   label="Ingresá los últimos 4 números de tu tarjeta Montemar" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}
const selector = formValueSelector('CreditCardForm');

CreditCardMontemar = connect(state => {
    const last_digits = selector(state, 'last_digits_credit_card');
    return {
        last_digits
    }
})(CreditCardMontemar)

export default CreditCardMontemar;



/** WEBPACK FOOTER **
 ** ./src/components/CreditCardMontemar.js
 **/